import React from 'react';
import PropTypes from 'prop-types';

// Section components
import Scratchpad from '../Scratchpad';
import PropertyTypes from '../PropertyTypes';
import Trending from '../Trending';
import Lyp from '../Lyp';
import { NewValueProps } from '../ValueProps';
import Linkpiles from '../Linkpiles';

import './Content.less';
import { Experiment } from '../Experiment';

// Map of components
const componentsMap = {
  'hp-linkpile': Linkpiles,
  'hp-lyp': Lyp
};

const CNAME = 'Content';

const Content = ({ sections }) => (
  <main role="main">
    <article className={CNAME}>
      <Experiment name="HA_PTA_HP_NewValueProps">
        {(value, experiment) => (experiment && value === 1 && <NewValueProps />)}
      </Experiment>
      <Scratchpad />
      <PropertyTypes />
      <Trending />
      {
        sections.map((section) => {
          const Component = componentsMap[section.id];
          return Component ?
            <section key={section.id} className={`${CNAME}__section`}>
              <Component {...section} />
            </section> : null;
        })
      }
    </article>
  </main>
);

Content.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.object)
};

export default Content;



// WEBPACK FOOTER //
// ./src/universal/components/Content/Content.js